import { Game } from '../../state/shared/games.types';
import { COLUMN_MIN_WIDTH, MAX_COLUMNS_COUNT } from './GamesRandomizer.content';

export const getColumnsCount = (gap: number, availableWidth: number) => {
  const calculate = (columnsCount: number): number => {
    const gaps = (columnsCount - 1) * gap;

    return (availableWidth - gaps) / columnsCount >= COLUMN_MIN_WIDTH
      ? columnsCount
      : calculate(columnsCount - 1);
  };

  return calculate(MAX_COLUMNS_COUNT);
};

export const getItemSize = (
  gap: number,
  columnsCount: number,
  availableWidth: number,
) => (availableWidth - (columnsCount - 1) * gap) / columnsCount;

export const getColumnHeight = (
  gap: number,
  gameIds: Array<Game['id']>,
  itemSize: number,
) => gameIds.length * itemSize + (gameIds.length - 1) * +gap;

export const getGameOffset = (gap: number, index: number, itemSize: number) =>
  index * itemSize + index * +gap;

export const getTargetGameOffset = (
  gap: number,
  columns: Array<Game['id'][]>,
  targetGameId: Game['id'],
  itemSize: number,
) => {
  const column = columns.find((column) => column.includes(targetGameId));

  return column && getGameOffset(gap, column.indexOf(targetGameId), itemSize);
};

export const getRandomIndex = (gameIds: Array<Game['id']>) =>
  Math.floor(Math.random() * gameIds.length);

export const getColumns = (games: Game[], columnsCount: number) => {
  if (!columnsCount) {
    return [];
  }

  const gamesPerColumn = Math.floor(games.length / columnsCount);

  return games.reduce(
    (accumulator: Array<Game['id'][]>, game, index) => {
      const { id, gameImages } = game;

      if (gameImages.square) {
        const columnIndex = Math.min(
          Math.floor(index / gamesPerColumn),
          columnsCount - 1,
        );
        const randomIndex = getRandomIndex(accumulator[columnIndex]);

        accumulator[columnIndex].splice(randomIndex, 0, id);
      }

      return accumulator;
    },
    Array.from({ length: columnsCount }, () => []),
  );
};
